import React, { useEffect, useMemo, useState } from 'react';
import { useHistory } from '../../../providers/HistoryProvider';
import { TemplateType } from '@neum/frontend-shared/constants/templateData';
import { DocumentActionPromptBanner } from '../common/DocumentActionPromptBanner';

export const ProcessAllNotesBanner: React.FC = () => {
    const {
        activeSession,
        template,
        setTemplate,
        processRecordings,
        multiDocEligible,
        activeSessionUpdated,
        allNotesMetadata,
        tab,
    } = useHistory()

    const [selectedLanguage, setSelectedLanguage] = useState<string>('English')

    useEffect(() => {
        if (activeSession?.spoken_language) {
            setSelectedLanguage(activeSession.spoken_language);
        } else if (tab === "discharge") {
            setSelectedLanguage("English (US)");
        }
    }, [activeSession, tab]);

    const allNotesMetadataRequireProcessing = useMemo(() => {
        return multiDocEligible ? allNotesMetadata?.filter(note => ["Updated", "Not Started", "Failed"].includes(note.status)) : undefined
    }, [multiDocEligible, allNotesMetadata]);

    const multipleProcessingRequired = useMemo(() => {
        return allNotesMetadataRequireProcessing !== undefined && allNotesMetadataRequireProcessing.length > 1
    }, [allNotesMetadataRequireProcessing]);

    const singleNoteMetadataToProcess = useMemo(() => {
        return allNotesMetadataRequireProcessing !== undefined && allNotesMetadataRequireProcessing.length === 1 ? allNotesMetadataRequireProcessing[0] : undefined
    }, [allNotesMetadataRequireProcessing]);

    const title = useMemo(() => {
        if (multipleProcessingRequired) {
            return activeSessionUpdated ? "Process new recordings?" : "Process recordings?"
        } else {
            return activeSessionUpdated ? "Done updating?" : "Done recording?"
        }

    }, [multipleProcessingRequired, activeSessionUpdated]);

    const description = useMemo(() => {
        if (multipleProcessingRequired) {
            return activeSessionUpdated ? "Process the latest recordings for all notes in this visit" : "Process the recordings for all notes in this visit"
        } else {
            return activeSessionUpdated ? "Process updates to this visit" : "Process the recordings for this visit"
        }
    }, [activeSessionUpdated, multipleProcessingRequired]);

    const buttonText = useMemo(() => {
        return (activeSessionUpdated ? "Update" : "Process") + (multipleProcessingRequired ? " All" : "")
    }, [activeSessionUpdated, multipleProcessingRequired]);

    return <DocumentActionPromptBanner 
        title={title}
        description={description}
        templateType={multipleProcessingRequired ? undefined : TemplateType.MEDICAL}
        template={multipleProcessingRequired ? undefined : template}
        setTemplate={multipleProcessingRequired ? undefined : setTemplate}
        templateIdForce={multipleProcessingRequired ? undefined : (multiDocEligible ? (singleNoteMetadataToProcess?.template_id ?? activeSession?.template_id) : activeSession?.template_id)}
        buttonText={buttonText}
        onButtonClick={() => processRecordings(activeSessionUpdated, selectedLanguage, template)}
        hideTemplatePicker={multipleProcessingRequired}
    />
};